import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./performanceApiClient";

export const getPerformanceRatingScales = async (params = {}) =>
  getRequest("/masters/rating-scales", { params });

export const getPerformanceRatingScale = async (ratingScaleId) =>
  getRequest(`/masters/rating-scales/${ratingScaleId}`);

export const createPerformanceRatingScale = async (payload) =>
  postRequest("/masters/rating-scales", payload);

export const updatePerformanceRatingScale = async (ratingScaleId, payload) =>
  putRequest(`/masters/rating-scales/${ratingScaleId}`, payload);

export const deletePerformanceRatingScale = async (ratingScaleId) =>
  deleteRequest(`/masters/rating-scales/${ratingScaleId}`);

export const activatePerformanceRatingScale = async (ratingScaleId) =>
  postRequest(`/masters/rating-scales/${ratingScaleId}/activate`, {});

export const archivePerformanceRatingScale = async (ratingScaleId) =>
  postRequest(`/masters/rating-scales/${ratingScaleId}/archive`, {});

export default {
  getPerformanceRatingScales,
  getPerformanceRatingScale,
  createPerformanceRatingScale,
  updatePerformanceRatingScale,
  deletePerformanceRatingScale,
  activatePerformanceRatingScale,
  archivePerformanceRatingScale,
};
